import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DndDropEvent } from 'ngx-drag-drop';
import { Editor, Toolbar } from 'ngx-editor';
import { ImageLayoutType } from 'src/app/components/Article/article-elements/article-image-layout-model/article-image-layout-model.component';
import { ArticleBlock, ArticleElementType } from 'src/app/models/article';

@Component({
  selector: 'app-ui-post',
  templateUrl: './ui-post.component.html',
  styleUrls: ['./ui-post.component.scss'],
})
export class UiPostComponent implements OnInit, OnDestroy {
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  // dropdownSettings: IDropdownSettings;
  editor: Editor;
  html = '';
  highLightTootlbar: Toolbar = [['bold', 'italic']];
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  ngOnInit() {
    this.dropdownList = [
      { item_id: 0, item_text: 'No Topic' },
      { item_id: 1, item_text: 'Lifestyle' },
      { item_id: 2, item_text: 'Entertainment' },
      { item_id: 3, item_text: 'Health' },
      { item_id: 4, item_text: 'Art' },
      { item_id: 5, item_text: 'Gaming' },
      { item_id: 6, item_text: 'News' },
      { item_id: 7, item_text: 'Tech' },
      { item_id: 8, item_text: 'Lifestyle' },
      { item_id: 9, item_text: 'Health' },
      { item_id: 10, item_text: 'Lifestyle' },
      { item_id: 11, item_text: 'Gaming' },
      { item_id: 12, item_text: 'Sports' },
      { item_id: 13, item_text: 'Culture' },
      { item_id: 14, item_text: 'Entertainment' },
      { item_id: 15, item_text: 'Tech' },
      { item_id: 16, item_text: 'Health' },
      { item_id: 17, item_text: 'News' },
      { item_id: 18, item_text: 'Celebrities' },
    ];
    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Health' },
    //   { item_id: 4, item_text: 'Art' },
    // ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      limitSelection: 3,
    };

    this.editor = new Editor();
  }

  isEyeVisible: boolean = true;

  onDragStart(event: DragEvent) {
    console.log('drag started', JSON.stringify(event, null, 2));
  }
  onDragover(event: DragEvent) {
    console.log('dragover', JSON.stringify(event, null, 2));
  }

  onDrop(event: DndDropEvent) {
    console.log('dropped', JSON.stringify(event, null, 2));
    console.log(event);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  // Modal Code
  private modalService = inject(NgbModal);
  openDeleteSectionModal(deleteSectionModal: TemplateRef<any>) {
    this.modalService.open(deleteSectionModal, {
      windowClass: 'delete-section-modal',
      centered: true,
      size: 'sm',
    });
  }
  openLayoutSelectModal(layoutSelect: TemplateRef<any>) {
    this.modalService.open(layoutSelect, {
      windowClass: 'layout-select-modal',
      centered: true,
    });
  }
  openAddHighlightModal(addHighlightModal: TemplateRef<any>) {
    this.modalService.open(addHighlightModal, {
      windowClass: 'highlight-menu dropdown-outer-block',
      centered: true,
    });
  }
  openDiscardChangesModal(discardChangesModal: TemplateRef<any>) {
    this.modalService.open(discardChangesModal, {
      windowClass: 'delete-section-modal discard-changes-modal',
      centered: true,
      size: 'sm',
    });
  }

  newBlock = {
    data: '',
    isActiveForEdit: true,
    elementId: 2,
    type: ArticleElementType.MainImage,
    displayOrder: 1,
    layout: ImageLayoutType.layoutSecond,
  } as ArticleBlock;

  swapImages(event: MouseEvent): void {
    const target = event.target as HTMLImageElement;
    const smallImgSrc = target.getAttribute('src');
    if (smallImgSrc) {
      const bigImg = document.querySelector('.big-img') as HTMLImageElement;
      if (bigImg) {
        const bigImgSrc = bigImg.src;
        bigImg.src = smallImgSrc;
        target.src = bigImgSrc;
      }
    }
  }
}
